import { render, staticRenderFns } from "./eb-card.vue?vue&type=template&id=754bb667&scoped=true&"
import script from "./eb-card.vue?vue&type=script&lang=js&"
export * from "./eb-card.vue?vue&type=script&lang=js&"
import style0 from "./eb-card.vue?vue&type=style&index=0&id=754bb667&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754bb667",
  null
  
)

export default component.exports